import styled from 'styled-components';

export const MediaExpandedList = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  grid-row-gap: 60px;
`;
